import { render, staticRenderFns } from "./PrinterLegalDocumentComponent.vue?vue&type=template&id=543f062d&scoped=true&"
import script from "./PrinterLegalDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./PrinterLegalDocumentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f062d",
  null
  
)

export default component.exports